import { ILeaseInvoice } from 'src/models/dlcLease/ILeaseInvoice';
import { ILease1099 } from 'src/models/dlcLease/ILeaseMaster';

export const DEFAULT_SEND_1099_TYPE = 'RE';

export const applySend1099Selection = (record: Partial<ILease1099>, value: 'Y' | 'N'): Partial<ILease1099> => {
    if (value === 'Y') {
        return {
            ...record,
            send1099: value,
            sendType: record.sendType || DEFAULT_SEND_1099_TYPE,
            noSendType: undefined,
            noSendReason: undefined,
        };
    }

    return {
        ...record,
        send1099: value,
    };
};

/**
 * Use the first active, non-voided invoice that has a Payment Due Date. Older
 * incomplete invoice records cannot provide a tax-year default, so continue to
 * the next eligible invoice. If no eligible invoice has a due date, stay blank.
 */
export const getPrimaryInvoiceDueDate = (invoices?: ILeaseInvoice[]): Date | string | undefined => {
    return (invoices || []).find((invoice) => invoice.operation !== 'delete' && !invoice.voidDate && !!invoice.dueDate1)?.dueDate1;
};



// WEBPACK FOOTER //
// ./src/components/leases/sections/lease1099Defaults.ts